import { useContext } from "react";
import { useGetCompany } from "../../../../api/company";
import { AR, BusinessFlow, FileTypes, KindOfOrder, ROType } from "../../../../types/enums";
import { FileAttachmentsButton } from "../../../common";
import { FileAttachment } from "../../../common/file-attachments/types/FileAttachment";
import { RefetchScope, RetailOrderContext } from "../context/RetailOrderContext";

export default function RetailOrderFilesButton(props: { defaultFileType?: FileTypes }) {

	const { order, modifyOrder, refetchOrder } = useContext(RetailOrderContext);
	const dealer = useGetCompany(order.details.dealerCompanyID);
	const defaultFileType = props.defaultFileType ??
		(order.details.activeARs.includes(AR.CfiToUploadCocInvoice) ?
			(order.details.roTypeID === ROType.Measure ? FileTypes.PostTemplateDrawing : FileTypes.COC) :
			order.details.activeARs.includes(AR.InstallerToUploadVerificationForm) ?
				FileTypes.WorkVerificationForm : undefined);

	return (
		<FileAttachmentsButton
			attachedFiles={order.details.files}
			orderID={order.details.retailOrderID}
			parentGuid={order.details.guid}
			kindOfOrder={KindOfOrder.RetailOrder}
			orderTypeID={order.details.roTypeID}
			IME={order.details.IME}
			defaultFileType={defaultFileType}
			fileTypeFilter={(fileType: FileTypes) => {
				if (fileType === FileTypes.DisplayPhoto) return true;

				if (order.details.activeARs.includes(AR.InstallerToUploadVerificationForm))
					return fileType === FileTypes.WorkVerificationForm;

				if (order.details.activeARs.includes(AR.CfiToUploadCocInvoice)) {
					if (order.details.roTypeID === ROType.Measure)
						return fileType === FileTypes.PostTemplateDrawing || fileType === FileTypes.CfiInvoice;
					else
						return fileType === FileTypes.COC || fileType === FileTypes.PostInstallChecklist ||
							fileType === FileTypes.CfiInvoice;
				}

				return true;
			}}
			hideDeleteButton={true}
			useFileTypes={true}
			onFileAdded={() => refetchOrder(RefetchScope.Files)}
			onFilesRetrieved={(files: FileAttachment[]) => {
				const existingFiles = order.details.files ?? [];
				const mergedFiles = [...existingFiles];

				for (const file of files) {
					const isExisting = existingFiles.some(existing =>
						existing.documentID === file.documentID ||
						existing.awsS3Key === file.awsS3Key);

					if (!isExisting) {
						mergedFiles.push(file);
					}
				}

				modifyOrder({
					...order.details,
					files: mergedFiles
				});
			}}
			onFileDeleted={() => refetchOrder(RefetchScope.Files)}
		/>
	)
}
